import type { MutableRefObject } from "react"
import { useRef, useEffect } from "react"

import { atomFamily, useSetRecoilState } from "recoil"

import type { Point2d } from "../utils/geometry"

const ORIGIN = { x: 0, y: 0 }

const findStudioCenterPositionState = atomFamily<Point2d, string>({
  key: `studio_center`,
  default: ORIGIN,
})

export const useSetStudioCenterPosition = <T extends HTMLElement>(
  key: string,
): MutableRefObject<T | null> => {
  const nodeRef = useRef<T | null>(null)
  const setPosition = useSetRecoilState(findStudioCenterPositionState(key))

  useEffect(() => {
    if (nodeRef.current) {
      const { clientHeight, clientWidth } = nodeRef.current || {
        clientHeight: 0,
        clientWidth: 0,
      }
      const x = clientWidth / 2
      const y = clientHeight / 2
      setPosition({ x, y })
    }
  }, [setPosition])

  return nodeRef
}
